<template>
  <v-container id="fcreate" fluid>
    <v-row>
      <v-col cols="12">
        <div class="text-h3 mb-2" v-text="getTitle" />
      </v-col>
      <v-col cols="12">
        <v-form ref="form" v-model="valid">
          <v-container fluid>
            <v-row>
              <!-- Название -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  label="Название"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Вес -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.weight"
                  label="Вес"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Белки -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.proteins"
                  label="Белки"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Жиры -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.fats"
                  label="Жиры"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Углеводы -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.carbohydrates"
                  label="Углеводы"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Калорийность -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.calories"
                  label="Калорийность"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Состав -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.composition"
                  label="Состав"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Состав для повара -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.compositionForCook"
                  label="Состав для повара"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Тип приготовления (Холодный/Жаренный/Запеченый/Варка) -->
              <v-col cols="12">
                <v-radio-group v-model="data.cookingType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Тип готовки: '" />
                  </template>
                  <v-radio value="cold" label="Холодный" />
                  <v-radio value="fried" label="Жаренный" />
                  <v-radio value="baked" label="Запеченый" />
                  <v-radio value="boiled" label="Варка" />
                </v-radio-group>
              </v-col>
              <!-- Класс блюда (ролл/закуска/пицца/салат/суп) -->
              <v-col cols="12">
                <v-radio-group v-model="data.dishType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Класс блюда: '" />
                  </template>
                  <v-radio value="roll" label="Ролл" />
                  <v-radio value="sushi" label="Суши" />
                  <v-radio value="pizza" label="Пицца" />
                  <v-radio value="salad" label="Салат" />
                  <v-radio value="soup" label="Суп" />
                  <v-radio value="drink" label="Напиток" />
                  <v-radio value="souse" label="Соус" />
                </v-radio-group>
              </v-col>
              <!-- Кто готовит (цех) - горячий/холодный/сборщик -->
              <v-col cols="12">
                <v-radio-group v-model="data.manufacturerType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Кто готовит: '" />
                  </template>
                  <v-radio value="cold" label="Холодный" />
                  <v-radio value="hot" label="Горячий" />
                  <v-radio value="collector" label="Сборщик" />
                </v-radio-group>
              </v-col>

              <!-- Цветовая маркировка -->
              <v-col cols="12" md="7">
                <v-select
                  v-model="data.colorMark"
                  outlined
                  :items="colorMarksAll"
                  label="Цветовая маркировка"
                  item-text="name"
                  item-value="code"
                >
                  <template slot="prepend-inner">
                    <div
                      style="display:inline-block; height: 24px; width: 24px; margin-right: 20px; vertical-align: middle; border-radius: 4px"
                      :style="{background: selectedColorMarkObject.value.color}"
                    ></div>
                  </template>
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          :id="attrs['aria-labelledby']"
                        >
                          <div
                            style="display:inline-block; height: 24px; width: 24px; margin-right: 20px; vertical-align: middle; border-radius: 4px"
                            :style="{background: item.color}"
                          ></div>
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

              <!-- Флаги для сборки-->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.addSpoon"
                  label="Добавлять ложку в сборке"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.addFork"
                  label="Добавлять вилку в сборке"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.customAssemblyCase"
                  label="Кастомный кейс сборки"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <!-- Комментарий от шеф-повара -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.chefComment"
                  label="Комментарий от шеф-повара"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Таймер приготовления в печи -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.cookingTime"
                  label="Таймер приготовления в печи (в минутах)"
                  :rules="rules.number"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Расчетное время приготовления -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.termTime"
                  label="Расчетное время приготовления (в минутах)"
                  :rules="rules.number"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Флаг необходимости термообработки -->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.hasTerm"
                  label="Необходимость термообработки"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Максимальное время нахождения приготовленного блюда в ячейке (время остывания) -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.timeToCool"
                  label="Максимальное время нахождения приготовленного блюда в ячейке (время остывания) (в минутах)"
                  :rules="rules.number"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Submit -->
              <v-col cols="12" md="7">
                <v-row>
                  <v-col>
                    <v-btn
                      class="mb-2"
                      block
                      large
                      color="success"
                      :loading="loadingForm"
                      :disabled="loadingForm"
                      @click.prevent="save"
                    >
                      Сохранить
                    </v-btn>
                  </v-col>

                  <v-col>
                    <v-btn
                      class="mb-2"
                      block
                      large
                      color="info"
                      :loading="loadingForm"
                      :disabled="loadingForm"
                      @click.prevent="save(false)"
                    >
                      Применить
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      block
                      large
                      color="error"
                      :loading="loadingForm"
                      :disabled="loadingForm"
                      @click.prevent="$router.push('/technicalCards')"
                    >
                      Отмена
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'
  import TCardColorMark from '../../models/enums/TCardColorMark'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {},
        edit: false,
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
        colorMarksAll: TCardColorMark.getAllVariants(),
      }
    },
    computed: {
      ...mapGetters({
        getTechnicalCards: 'technicalCards/getTechnicalCardsSingle',
      }),
      getId () { return this.$route.params.id || null },
      getName () { return this.getTechnicalCards ? this.getTechnicalCards.name : '' },
      getTitle () { return `Техническая карта: "${this.getName}"` },
      selectedColorMarkObject () {
        return new TCardColorMark(this.data.colorMark)
      },
    },
    async created () {
      if (this.getId) {
        this.loading = true
        await this.$store.dispatch('technicalCards/fetchSingleTechnicalCards', this.getId)
          .then((res) => {
            if (res.status === 200) {

            }
          }).finally(() => {
            this.loading = false
          })

        this.editTechnicalCards()
      } else {
        this.$router.push('/technicalCards')
      }
    },
    beforeDestroy () {
      this.$store.commit('technicalCards/clearTechnicalCardsSingle')
    },
    methods: {
      editTechnicalCards () {
        this.data = {
          name: this.getTechnicalCards.name,
          termTime: this.getTechnicalCards.termTime,
          weight: this.getTechnicalCards.weight,
          proteins: this.getTechnicalCards.proteins,
          fats: this.getTechnicalCards.fats,
          carbohydrates: this.getTechnicalCards.carbohydrates,
          calories: this.getTechnicalCards.calories,
          composition: this.getTechnicalCards.composition,
          compositionForCook: this.getTechnicalCards.compositionForCook,
          chefComment: this.getTechnicalCards.chefComment,
          cookingType: this.getTechnicalCards.cookingType,
          dishType: this.getTechnicalCards.dishType,
          manufacturerType: this.getTechnicalCards.manufacturerType,
          colorMark: this.getTechnicalCards.colorMark,
          timeToCool: this.getTechnicalCards.timeToCool,
          cookingTime: this.getTechnicalCards.cookingTime,
          hasTerm: this.getTechnicalCards.hasTerm,
          sortOrder: this.getTechnicalCards.sortOrder,
          createdAt: this.getTechnicalCards.createdAt,
          updatedAt: this.getTechnicalCards.updatedAt,
          addSpoon: this.getTechnicalCards.addSpoon,
          addFork: this.getTechnicalCards.addFork,
          customAssemblyCase: this.getTechnicalCards.customAssemblyCase,
        }
        this.selectVModel = this.getFilials
          ? this.getFilials.map((v) => v.name)
          : []
      },
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loadingForm = true
          try {
            this.data.filials = this.selectDataArray
            const res = await this.$store.dispatch('technicalCards/editTechnicalCards', {
              data: this.data,
              id: this.getId,
            })

            if (res.status && res.status === 200 && redirect) {
              this.$router.push('/technicalcards')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) {
            console.log(e)
          }
          this.loadingForm = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
